import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
//Slices
import authReducer from "./slice/authSlice";
import loadingReducer from "./slice/loadingSlice";
import usersReducer from "./slice/usersSlice";
import serviceProviderReducer from "./slice/servideProvidersSlice";
import rolesReducer from "./slice/roles";
import membershipsReducer from "./slice/membershipsSlice";
import promotionsReducer from "./slice/promotions";
import badgesReducer from "./slice/badgesSlice";

const persistConfig = {
  key: "root",
  storage,
};

const combinedReducers = combineReducers({
  authReducer,
  loadingReducer,
  serviceProviderReducer,
  usersReducer,
  rolesReducer,
  membershipsReducer,
  promotionsReducer,
  badgesReducer,
});

const persistedReducer = persistReducer(persistConfig, combinedReducers);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }),
});

const persistor = persistStore(store);

export { store, persistor };
